module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-wrapper",
    attrs: {
      "id": "tsection"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.toggle) ? _c('div', {
    staticClass: "active-nav"
  }, [_c('div', {
    staticClass: "link shorthand"
  }, [(false) ? _c('div', {
    staticClass: "small-div"
  }, [_c('a', {
    staticClass: "div-link",
    attrs: {
      "href": "http://shop.lasting-impressions.com.my"
    }
  }, [_vm._v("\n          Shop\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "small-div"
  }, [_c('a', {
    staticClass: "div-link",
    attrs: {
      "href": "/?anchor=gallery-container"
    }
  }, [_vm._v("\n          Gallery\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "small-div"
  }, [_c('a', {
    staticClass: "div-link",
    attrs: {
      "href": "/about"
    }
  }, [_vm._v("\n          About\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "small-div"
  }, [_c('a', {
    staticClass: "div-link",
    attrs: {
      "href": "/locate"
    }
  }, [_vm._v("\n          Locate\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "small-div"
  }, [_c('div', [_c('a', {
    staticClass: "elink",
    attrs: {
      "href": "mailto:sales@lasting-impressions.com.my;jonathan@lasting-impressions.com.my"
    }
  }, [_vm._v("sales@lasting-impressions.com.my")])])]), _vm._v(" "), _c('div', {
    staticClass: "small-div"
  }, [_c('div', {
    staticClass: "eicon"
  }, [_c('a', {
    staticClass: "top-icon facebook",
    attrs: {
      "href": "https://www.facebook.com/lastingimpressionskl",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "small-div"
  }, [_c('div', {
    staticClass: "eicon"
  }, [_c('a', {
    staticClass: "top-icon instagram",
    attrs: {
      "href": "https://www.instagram.com/lastingimpressionskl",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "full-layer"
  }, [_c('navbar-full', {
    attrs: {
      "toggle": _vm.toggle
    },
    on: {
      "onToggle": function($event) {
        _vm.toggle = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c1cc805","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBarOverlay.vue
// module id = 730
// module chunks = 1